export function filterAdditionalDepartmentOptions<T extends { id: number }>(
    departments: T[],
    primaryDepartmentId: number | null | undefined,
): T[] {
    if (primaryDepartmentId == null) {
        return departments;
    }

    return departments.filter(department => department.id !== primaryDepartmentId);
}

export function removePrimaryDepartmentFromAdditionalIds(
    additionalDepartmentIds: number[] | null | undefined,
    primaryDepartmentId: number | null | undefined,
): number[] {
    const ids = additionalDepartmentIds ?? [];

    if (primaryDepartmentId == null) {
        return ids;
    }

    return ids.filter(id => id !== primaryDepartmentId);
}
